module.exports = __webpack_public_path__ + "static/img/tuixi.b7d4eefc.png";